// Recognises the errors Blazor raises for a call into .NET while the circuit is gone. Shared by the core's log
// forwarder and the popover module, which both stay quiet then instead of reporting their own failed sends.

const DWS_DISCONNECTED_PATTERN = /connection is not in the 'Connected' State|circuit.*(disconnected|closed)|No interop methods are registered/i;

export function isDwsDisconnectedError(message: unknown): boolean {
    return typeof message === 'string' && DWS_DISCONNECTED_PATTERN.test(message);
}
